import axios from 'axios';
import config from '../../helpers/config.helper';
import RoutesConstants from '../../shared/components/Routes/routes.constants';
import store from '../store/store';

const appConfig = config();
export const baseURL = appConfig.REACT_APP_API_URL;
export const baseAPI = axios.create({ baseURL });

const requestHandler = (request: any) => {
    const token = store.getState().auth.token;
    request.headers['authorization'] = 'Bearer ' + token;
    return request;
};

const errorHandler = (error: any) => {

    let message: string = "Message_Some_Error_Occured";

    if (error.response && error.response !== "null" && error.response !== undefined) {
        if (error.response.status === 401) {
            message = "Unauthorized";
            return window.location.href = RoutesConstants.Login;
        } else if (error.response.status === 403) {
            message = "Unauthorized_Access";
        } else if (error.response.data.message && error.response.data.message !== "null" && error.response.data.message !== undefined) {
            message = error.response.data.message
        }
    }
    return Promise.reject(message);
};

const successHandler = (response: any) => {
    return response;
};

baseAPI.interceptors.request.use(request => requestHandler(request));
baseAPI.interceptors.response.use(
    response => successHandler(response),
    error => errorHandler(error)
);

